<template>
	<div id="home">
		<h1 style="color:white;">HOME</h1>
	</div>
</template>

<script>
	import isLoggedIn from '../services/IsLoggedIn.js';
	import {EventBus} from '@/services/EventBus.js';

	export default {
		name: 'Home',
		async created() {
			EventBus.$emit('onCurrentShow', '');

			if(await isLoggedIn() === true) {
				this.$router.push('/shows');
			} else {
				this.$router.push('/login');
			}
		}
	}
</script>

<style scoped>

</style>